import * as React from "react";
import classes from "./AdminLayout.module.scss";
import SideBar from "../../components/Admin/SideBar/Sidebar";
import { Header } from "../../components/Admin/Header/Header";
import AdminRoutes from "../../components/Routes/AdminRoutes";
import { FC, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { buildAdminPath } from "../../constants/routes";
import { useGetCurrentLicenseData } from "../../hooks/license/useGetCurrentLicenseData";
import { LicenseHasExpiredModal } from "../../components/LicenseModals/LicenseHasExpiredModal/LicenseHasExpiredModal";
import { LicenseAboutExpireModal } from "../../components/LicenseModals/LicenseAboutExpireModal/LicenseAboutExpireModal";
import {
  useMyPermissions,
  getPermissionKeyForPathname,
} from "../../hooks/useMyPermissions";
import { getUserData } from "../../utils/Authorization/authorization";

type AdminLayoutProps = {
  setIsAuthenticated: (status: boolean) => void;
};

const AdminLayout: FC<AdminLayoutProps> = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { canView, getFirstAllowedPath, isLoading } = useMyPermissions();
  useGetCurrentLicenseData();

  useEffect(() => {
    if (isLoading) return;
    const pathname = location.pathname;
    const baseAdmin = buildAdminPath("");
    const isAdminRoot =
      pathname === baseAdmin || pathname === "/admin" || pathname === "/admin/";

    if (isAdminRoot) {
      navigate(getFirstAllowedPath(), { replace: true });
      return;
    }

    const permissionKey = getPermissionKeyForPathname(pathname);
    if (permissionKey === null) return;

    if (permissionKey === "") {
      const userRole = (getUserData() as { role?: string })?.role ?? "";
      const isBranchOrSuper =
        userRole.trim() === "Суперадминистратор Tehnosky" ||
        userRole.trim().startsWith("Администратор");
      if (!isBranchOrSuper) navigate(getFirstAllowedPath(), { replace: true });
      return;
    }

    if (!canView(permissionKey)) {
      navigate(getFirstAllowedPath(), { replace: true });
    }
  }, [location.pathname, isLoading, canView, getFirstAllowedPath, navigate]);

  return (
    <div className={classes.appContainer}>
      <SideBar />
      <div className={classes.rightPart}>
        <Header setIsAuthenticated={setIsAuthenticated} />
        <div>
          <AdminRoutes />
        </div>
      </div>

      <LicenseHasExpiredModal />
      <LicenseAboutExpireModal />
    </div>
  );
};

export default AdminLayout;
